var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 97,
    viewBox: "0 0 127 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.6329 4.91371e-06C84.21 -0.007024 105.11 7.52713 121.721 21.3002C126.822 25.4568 127.804 30.0415 124.542 33.984C121.28 37.9262 116.984 37.6496 111.946 33.694C81.4531 9.28287 45.3008 9.34585 14.756 33.8829C10.045 37.6619 5.29678 37.6619 2.23577 33.7441C-0.824334 29.8272 0.00761992 25.8215 4.70545 21.8793C20.9237 8.1413 41.3818 0.413766 62.6327 0.000128469L62.6329 4.91371e-06Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1291 25.6347C79.8432 26.0186 93.9465 31.5961 104.945 41.3794C109.593 45.4728 110.337 50.1086 107.061 53.7863C103.963 57.3131 99.3652 57.1242 94.9441 53.434C75.0681 36.9458 52.5457 36.9337 32.3924 53.434C27.5556 57.313 23.0087 57.313 19.8344 53.4463C16.8496 49.7562 17.6053 45.5237 22.0388 41.4805C32.9223 31.5671 48.7284 25.5592 65.13 25.6347L65.1291 25.6347Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5664 51.0887C72.8165 51.3831 81.6781 54.872 88.6456 60.9643C92.6135 64.4911 93.1045 69.1511 90.0944 72.5902C87.2732 75.8147 82.7132 76.0536 78.7586 73.1947C66.8306 64.6678 60.3939 64.6545 48.3892 73.1314C44.258 76.0537 39.9001 75.8269 37.0534 72.5647C34.0302 69.0503 34.5968 64.4024 38.4768 60.8889C44.635 55.2709 55.4798 51.0133 63.5672 51.0889L63.5664 51.0887Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3573 78.3631C65.8605 78.3526 68.267 79.327 70.0585 81.0755C71.8491 82.8239 72.8807 85.2067 72.9308 87.709C72.8333 90.1155 71.8431 92.3991 70.1519 94.1133C68.4606 95.8275 66.1912 96.8502 63.7863 96.9793C61.284 96.9933 58.8818 96.0022 57.1177 94.2284C55.3536 92.4546 54.3756 90.0471 54.4019 87.5457C54.3791 85.1417 55.3078 82.8268 56.9859 81.1063C58.664 79.386 60.9547 78.3993 63.3576 78.3633L63.3573 78.3631Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiIcon);
export default __webpack_public_path__ + "static/media/wifiIcon.bb4f79b19f5d279e309fea4180f8808e.svg";
export { ForwardRef as ReactComponent };